import { render, staticRenderFns } from "./sup-verify-your-account.vue?vue&type=template&id=2fc20b0d"
import script from "./sup-verify-your-account.vue?vue&type=script&lang=js"
export * from "./sup-verify-your-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports